{
  "rules": [
    {
      "index": 1,
      "text": "Din <strong>gjeld</strong>"
    },
    {
      "index": 2,
      "text": "Din <strong>kredittscore</strong>"
    },
    {
      "index": 3,
      "text": "Dine <strong>betalingsanmerkninger</strong>"
    },
    {
      "index": 4,
      "text": "og et <strong>gratis</strong> estimat av din <strong>boligverdi</strong>."
    }
  ]
}
